import mitt, { EventType, Handler, WildcardHandler } from 'mitt';

export interface MittProps {
  $on<T = any>(type: EventType, handler: Handler<T>): void;
  $on(type: '*', handler: WildcardHandler): void;
  $off<T = any>(type: EventType, handler: Handler<T>): void;
  $off(type: '*', handler: WildcardHandler): void;
  $emit<T = any>(type: EventType, event?: T): void;
  $emit(type: '*', event?: any): void;
}

const emitter = mitt();
const bus: MittProps = {
  $on: emitter.on,
  $off: emitter.off,
  $emit: emitter.emit
};

export default bus;
